export default "__VITE_ASSET__zkX3vWXf__"